import { actionTypes } from './actions';

const initialState = {
  categories: [],
  error: false,
  loading: false,
};

const handleGetExpenseCategoriesRequest = (state) => ({
  ...state,
  loading: true,
});

const handleGetExpenseCategoriesSuccess = (state, action) => ({
  ...state,
  categories: action.payload.category_groups,
  loading: false,
});

const handleGetExpenseCategoriesError = (state, action) => ({
  ...state,
  loading: false,
  error: action.error,
});

export default (state = initialState, action) => {
  const handlers = {
    [actionTypes.request]: handleGetExpenseCategoriesRequest,
    [actionTypes.success]: handleGetExpenseCategoriesSuccess,
    [actionTypes.error]: handleGetExpenseCategoriesError,
  };
  return handlers[action.type] ? handlers[action.type](state, action) : state;
};
